import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	CreateRevisionButton,
	CustomerInformationPanel,
	EstimateFilesButton,
	EstimateInformationPanel,
	EstimateItemsGrid,
	EstimateNotesGrid,
	EstimatePage,
	ExitButton,
	StoreInformationPanel,
	PrintInternalCostButton,
	PrintRetailPriceButton
} from '../../../features/dealer/estimate';
import '../../../css/order.scss';
import { useTitle } from '../../../contexts/title';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'devextreme-react';
import PlaceOrderButton from "../../../features/dealer/estimate/components/PlaceOrderButton";
import ConfirmOrderButton from "../../../features/dealer/estimate/components/ConfirmOrderButton";

export default function EstimateDetailsPage() {

	const customerInfoRef = useRef<{ save: (e: any) => void }>(null);

    const handleSave = (e: any) => {
        if (customerInfoRef.current) {
            customerInfoRef.current.save(e);
        }
    };

	const [editMode, setEditMode] = useState(false);

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Estimate Details')
	}, [pageTitle]);

	return (

		<EstimatePage>

			<Toolbar className='button-toolbar'>
				{<ToolbarItem location={'before'}>
					<Button
						text="Save Changes"
						icon="Inscyth-Save"
						validationGroup="customerInformationValidationGroup"
						elementAttr={{ 'data-testid': 'btn-save' }}
						disabled={!editMode}
						onClick={(e) => {
							if (e.validationGroup.validate().isValid) {
								handleSave(e);
							}
						}}
					>
					</Button>
				</ToolbarItem>}
				<ToolbarItem location={'before'}>
					<CreateRevisionButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<EstimateFilesButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PrintRetailPriceButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PrintInternalCostButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<PlaceOrderButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ConfirmOrderButton />
				</ToolbarItem>
				<ToolbarItem location={'before'}>
					<ExitButton />
				</ToolbarItem>
			</Toolbar>
			<Box>
				<Item ratio={1}>
					<EstimateInformationPanel />
				</Item>
				<Item ratio={1}>
					<CustomerInformationPanel ref={customerInfoRef} setEditMode={setEditMode} />
				</Item>
				<Item ratio={1}>
					<StoreInformationPanel />
				</Item>
			</Box>

			<EstimateItemsGrid />

			<EstimateNotesGrid />

		</EstimatePage>
	)
}
